import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { IdentitySecurityService } from 'src/app/services/identitySecurity';
import { ToastService } from 'src/app/services/toast.service';
import { lastValueFrom } from 'rxjs';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-disable-dialog',
  templateUrl: './disable-dialog.component.html'
})
export class DisableDialogComponent implements OnInit {
  @Input('userId') userId!: string;
  @Input('disableType') disableType!: string;
  translations = <any>{};
  form: UntypedFormGroup;
  disabled: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder, public activeModal: NgbActiveModal, private securityService: IdentitySecurityService, private toastService: ToastService, private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.form = this.formBuilder.group(
      {
        password: new UntypedFormControl('', [Validators.required]),
      }
    );
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.PasswordValidationSomethingWrong',
      'Toasts.Error'
    ]).subscribe(translation => {
      this.translations.toastsPasswordValidationSomethingWrong = translation['Toasts.PasswordValidationSomethingWrong'];
      this.translations.error = translation['Toasts.Error'];
    });
  }

  disableSecurityItem() {
    this.securityService.checkPassword(this.userId, this.form.controls['password'].value)
      .then(value => {
        lastValueFrom(value)
          .then(() => {
            this.disabled = true;
            this.activeModal.close();
          })
          .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsPasswordValidationSomethingWrong + ""));
      })
      .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsPasswordValidationSomethingWrong + ""));
  }

  async close(){
    this.activeModal.close();
  }

}
